export default $timeout => {
  $timeout(() => {
    var tmp = document.createElement('input');
    document.body.appendChild(tmp);
    tmp.click();
    document.body.removeChild(tmp);
  });
};



// WEBPACK FOOTER //
// ./client/app/common/utils/blur.js